<div
  class="cover-container"
  [ngClass]="
    column.selfDefined && !isDraggedInstallationAlreadyPresent ? 'allowed-drop' : 'disabled-drop'
  "
>
  <h3 class="cover-header">
    <span class="cover-header__name">
      {{ column.name | kanbanColumnName }}
    </span>
    <span> ({{ column.installations.length }}) </span>
  </h3>

  <div class="description">
    <ng-container *ngIf="column.selfDefined && !isDraggedInstallationAlreadyPresent">
      <mat-icon>location_on</mat-icon>

      <p>
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.DRAGGING_COVER.ALLOWED' | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="column.selfDefined && isDraggedInstallationAlreadyPresent">
      <mat-icon>warning</mat-icon>
      <p>
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.DRAGGING_COVER.ALREADY_COPIED' | translate }}
      </p>
    </ng-container>
    <ng-container *ngIf="!column.selfDefined">
      <mat-icon>warning</mat-icon>
      <p>
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.DRAGGING_COVER.FIXED_COLUMN' | translate }}
      </p>
    </ng-container>
  </div>
</div>
